module.exports = __webpack_public_path__ + "img/tulihover.5f87c601.png";